/**
 * Zugang zu den oeffentlichen Event-Endpunkten.
 *
 * Host und Mandant standen vorher doppelt im Code (IndividualSection und
 * Ticketabruf). Doppelte hartkodierte Adressen laufen frueher oder spaeter
 * auseinander -- deshalb genau eine Stelle.
 *
 * ACHTUNG: Der Host ist fest verdrahtet und zeigt auf die Testumgebung. Die
 * Erlebnisreisen kommen damit fuer JEDEN Mandanten aus derselben Umgebung.
 * Das ist bekannt und gehoert umgestellt, sobald die Events produktiv laufen.
 */
export const API_BASE = "https://www2.tstsrv.de/ibeapi/api/v1";

/**
 * Geteilter Mandant. Events gibt es in zwei Herkuenften -- geteilt und
 * mandantenspezifisch. Heute fragen wir nur die geteilten ab; die eigenen
 * Events eines Mandanten sind damit unsichtbar. Bewusst zurueckgestellt, siehe
 * systemdocumentation/architecture/KONZEPT_buendelkarte-und-bausteine.md
 */
export const PUBLIC_TENANT = "00000000-0000-0000-0000-000000000000";
